import { Boxes, Zap, Scissors, Printer, Droplets, Shirt, Gift } from "lucide-react";

// ============================================================
// EDIT ME — this single file holds the site's words, photos and
// contact details so everything is easy to update in one place.
// ============================================================

export const BUSINESS = {
  name: "Skies The Limit Creations LLC",
  email: "skiesthelimitcreationsllc@gmail.com",
  phoneDisplay: "803-262-3130",
  phoneHref: "tel:+18032623130",
  instagram: {
    label: "@skiesthelimitcreations",
    href: "https://www.instagram.com/skiesthelimitcreations",
  },
  // ---- PLACEHOLDERS for you to fill in (leave null to hide) ----
  address: null, // e.g. "123 Main St, Anytown, SC" or "Serving the greater ___ area"
  hours: null, // e.g. "Mon–Fri 9am–5pm"
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Our Work", to: "/work" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    slug: "3d-printing",
    name: "3D Printing",
    icon: Boxes,
    tag: "Our newest tool",
    short: "Custom pieces built layer by layer — from organization letters to one-of-a-kind gifts.",
    what: "3D printing builds a real object from a digital file, one thin layer at a time. Send us a sketch, a file, or just a description of what you need and we'll help you make it real.",
    examples: [
      "Organization letters & keepsakes in official colors",
      "Fan chains & spirit gear in your school colors",
      "Gifts and decor made from your ideas",
    ],
    goodFor: ["Individuals", "Businesses", "Organizations"],
    detailNote: "Filament colors & sizes: [add your options]",
    image: "/images/work-3d-letters-portrait.jpg",
    imageAlt: "3D printed Omega Psi Phi and Delta Sigma Theta Greek letters in official colors — 'Your Letters. Custom Made.', personalized with member details, matching mini easels included",
    extraImage: "/images/work-3d-fan-chains.jpg",
    extraImageAlt: "Custom 3D-printed SC State Bulldogs fan chains — 'Rep Your Colors' — S-shaped pendants with the Bulldog mascot in navy and red colorways",
    extraImageCaption: "'Rep Your Colors' — 3D-printed fan chains, dual colorways",
    video: "/videos/3d-printing-reel.mp4",
    videoWebm: "/videos/3d-printing-reel.webm",
    videoPoster: "/images/3d-reel-poster.jpg",
    videoAlt: "Animated showcase of custom 3D-printed Greek letters and fan chains from our workshop",
    videoFirst: true,
  },
  {
    slug: "laser-engraving",
    name: "Laser Engraving",
    icon: Zap,
    tag: "Our newest tool",
    short: "Names, logos, and designs engraved to last — monogrammed boards, coasters, gifts, and awards.",
    what: "Laser engraving etches your design directly into the surface of the piece, so it won't peel, crack, or wash out. Bring us a logo, a monogram, or a phrase and we'll help you pick the right piece to put it on.",
    examples: [
      "Monogrammed bamboo boards & slate coasters",
      "Engraved gifts and awards",
      "Keepsakes for weddings, retirements, and milestones",
    ],
    goodFor: ["Businesses", "Teams", "Gift givers"],
    detailNote: "Materials shown in our work: bamboo & slate — ask about others",
    image: "/images/work-laser-bulldog-suite.jpg",
    imageAlt: "Round slate centerpiece plaque laser-engraved with the South Carolina State University Bulldog and alma mater, with matching slate coasters and custom coaster holders",
    extraImage: "/images/work-laser-board.jpg",
    extraImageAlt: "Custom laser-engraved bamboo cutting board with a 'W Wilcoxson' laurel monogram, on a personalized stand",
    extraImageCaption: "'The Gift of Family Legacy' — bamboo board, stand included",
    extraImage2: "/images/engraving-mcgraw-set.jpg",
    extraImage2Alt: "Laser-engraved maple cutting board with a 'McGraw' laurel monogram beside a matching engraved slate tile reading 'The McGraw Family — Est. 2010', styled on a kitchen counter",
    extraImage2Caption: "The McGraw Family set — maple board & slate tile",
    video: "/videos/laser-engraving-reel.mp4",
    videoWebm: "/videos/laser-engraving-reel.webm",
    videoPoster: "/images/laser-reel-poster.jpg",
    videoAlt: "Workshop reel of custom laser-engraved monogram pieces",
  },
  {
    slug: "embroidery",
    name: "Embroidery",
    icon: Scissors,
    tag: "Where we started",
    short: "Stitched logos, names, and numbers on caps, jackets, sweatshirts, and more — this is where our story began.",
    what: "Embroidery is stitching — thread sewn right into the garment. It's the finish people notice on team jackets, company polos, and caps. Embroidery is our first love, and it shows in the detail of our work.",
    examples: [
      "Team jackets, caps, and sweatshirts",
      "Logo patches and left-chest designs",
      "Names, numbers, and monograms",
    ],
    goodFor: ["Teams", "Schools", "Businesses"],
    detailNote: null,
    image: "/images/work-emb-bulldog-legacy.jpg",
    imageAlt: "'Wear the Bulldog Legacy' — intricate dual-panel embroidery, 1896 Heritage Edition: SC State jacket with bulldog S patch and 1896 sleeve numbers",
    video: "/videos/embroidery-legacy-reel.mp4",
    videoWebm: "/videos/embroidery-legacy-reel.webm",
    videoPoster: "/images/embroidery-legacy-poster.jpg",
    videoAlt: "Animated showcase of the SC State Bulldog Legacy embroidered jacket collection and custom patches",
    videoCaption: "The Bulldog Legacy collection — embroidered in-house",
    video2: {
      src: "/videos/embroidery-reel.mp4",
      webm: "/videos/embroidery-reel.webm",
      poster: "/images/embroidery-reel-poster.jpg",
      alt: "Machine embroidery in progress — white thread stitching the word 'Luxury' onto vibrant blue fabric",
      caption: "The machine at work — stitching in-house",
    },
    videoReplacesImage: true,
    videoFirst: true,
    sectionImages: [
      {
        src: "/images/work-emb-bulldog-legacy.jpg",
        alt: "'Wear the Bulldog Legacy' — intricate dual-panel embroidery, 1896 Heritage Edition: SC State jacket with bulldog S patch and 1896 sleeve numbers",
      },
      {
        src: "/images/work-emb-legacy-model.jpg",
        alt: "'SC State Bulldog Legacy' — custom 1896 collegiate embroidery: man wearing an olive SC State jacket with embroidered back patch",
      },
      {
        src: "/images/work-emb-high-density.jpg",
        alt: "'SC State Bulldogs' — custom high-density embroidery: jacket back with bulldog S patch, Skies The Limit sleeve patch, and 1896 numbers",
      },
      {
        src: "/images/work-emb-earn-stripes.jpg",
        alt: "'Earn Your Stripes' — Class of '25 exclusive Orangeburg-Wilkinson Bears letterman jacket with embroidered mascot and C/O '25 patches",
      },
      {
        src: "/images/emb-warrior-spirit.jpg",
        alt: "'Warrior Spirit' — authentic tackle-twill embroidery on heavyweight fleece: HS HP Warriors sweatshirts worn on the football field at dusk",
      },
      {
        src: "/images/emb-warriors-campus.jpg",
        alt: "'Wear Your Pride Together' — custom tackle-twill embroidery: HS HP Warriors grey and black sweatshirts worn laughing across campus in warm light",
      },
      {
        src: "/images/emb-warriors-studio.jpg",
        alt: "'Wear Your Pride Together' — custom tackle-twill embroidery on heavyweight fleece: HS HP Warriors sweatshirts, studio shot on blue",
      },
    ],
  },
  {
    slug: "dtf-printing",
    name: "DTF Printing",
    icon: Printer,
    tag: "Full color, any fabric",
    short: "Vibrant full-color prints pressed onto apparel — and DTF transfers sold by size so you can press your own.",
    what: "Direct-to-film (DTF) printing prints your design in full color onto transfer film, then heat-presses it onto the garment. It handles detailed, multi-color artwork beautifully — and we sell the transfers by size too, so you can press them yourself.",
    examples: [
      "Full-color custom tees",
      "Team and event shirts",
      "DTF transfers sold by size for at-home pressing",
    ],
    goodFor: ["Individuals", "Teams", "Schools"],
    detailNote: null,
    image: "/images/work-dtf-rolls.jpg",
    imageAlt: "Rolls of freshly printed DTF transfers, ready to be heat-pressed onto apparel",
    sectionImages: [
      {
        src: "/images/dtf-vivid-detail.jpg",
        alt: "Vivid Detail. Industrial Precision. — our DTF printer laying down high-density gorilla artwork on transfer film",
      },
      {
        src: "/images/dtf-film-to-apparel.jpg",
        alt: "From Film to Finished Apparel — ultra-vibrant ink saturation: a commercial DTF printer rolling fresh transfers beside finished tees and hoodies",
      },
      {
        src: "/images/apparel-print-fidelity.jpg",
        alt: "Flawless Print Fidelity — our commercial Ricoh DTF printer beside a 'Savage Society King Primal' transfer and the finished black tee",
      },
      {
        src: "/images/apparel-film-to-streetwear.jpg",
        alt: "From Film to Finished Streetwear — a hand peels the DTF transfer off a blue tee, revealing a crisp bulldog print",
      },
    ],
  },
  {
    slug: "sublimation",
    name: "Sublimation",
    icon: Droplets,
    tag: "Edge-to-edge color",
    short: "Dye-printed designs that bond into the item itself for a smooth, fade-resistant finish.",
    what: "Sublimation turns ink into gas under heat, bonding the design into a coated surface instead of sitting on top of it. The result is a smooth, durable finish that won't crack or peel.",
    examples: [
      "Full-coverage apparel designs",
      "Photo gifts and keepsakes",
      "Custom promotional items",
    ],
    goodFor: ["Individuals", "Businesses", "Events"],
    detailNote: "Sublimation products available: [add your blanks — e.g., mugs, tumblers, shirts]",
    image: null,
    imageAlt: "",
    sectionImages: [
      {
        src: "/images/sub-veterans-tribute.jpg",
        alt: "'Enduring Civic Tribute' — Orangeburg County Veterans Council patch with six official service emblems (Army, Marine Corps, Navy, Space Force, Coast Guard) and a gold merrowed border",
      },
      {
        src: "/images/sub-veterans-branches.jpg",
        alt: "'Crafted to Honor Every Branch' — high-density merrowed gold border and detail: a batch of official Orangeburg County Veterans Council veteran insignia patches on the cutting mat",
      },
    ],
  },
  {
    slug: "custom-apparel",
    name: "Custom Apparel",
    icon: Shirt,
    tag: "Wear your story",
    short: "Team apparel, business shirts, and personal pieces — printed or stitched to fit your look and budget.",
    what: "Bring us your design or let us help you shape it. We'll recommend the right method — embroidery, DTF, or sublimation — for your garment, artwork, and quantity, then make it happen.",
    examples: [
      "Team and school spirit wear",
      "Business uniforms and polos",
      "Family reunion and event shirts",
    ],
    goodFor: ["Teams", "Schools", "Businesses", "Families"],
    detailNote: null,
    image: "/images/work-tee-bruins.jpg",
    imageAlt: "Custom team t-shirt reading 'Property of Orangeburg-Wilkinson Bruins 1990'",
    sectionImages: [
      {
        src: "/images/apparel-film-to-fabric.jpg",
        alt: "'From Film to Fabric' — vibrant full-color DTF: a bulldog 'Skies Limit Creations' transfer beside the finished print on a grey sweatshirt",
      },
      {
        src: "/images/apparel-film-to-streetwear.jpg",
        alt: "'From Film to Finished Streetwear' — a hand peels the DTF transfer off a blue tee, revealing a crisp bulldog print",
      },
      {
        src: "/images/apparel-blue-bear-tee.jpg",
        alt: "Royal blue tee with a full-color DTF graphic of a cartoon bear in a cap and shades — 'Create, Wear, Repeat' studio scene",
      },
      {
        src: "/images/apparel-print-fidelity.jpg",
        alt: "'Flawless Print Fidelity' — our commercial Ricoh DTF printer beside a 'Savage Society King Primal' transfer and the finished black tee",
      },
      {
        src: "/images/apparel-flawless-artwork.jpg",
        alt: "'Flawless Artwork. Zero Resolution Lost.' — peeling a full-color bulldog DTF transfer off a light blue hoodie, ultra-crisp micro detail",
      },
    ],
  },
  {
    slug: "personalized-gifts",
    name: "Personalized Gifts",
    icon: Gift,
    tag: "One of a kind",
    short: "Gifts for weddings, birthdays, holidays, and milestones — made around your person.",
    what: "The best gifts can't be bought off a shelf. Tell us who it's for and we'll mix any of our services — engraving, printing, embroidery, 3D printing — to make something that's just for them.",
    examples: [
      "Wedding and anniversary keepsakes",
      "Birthday and holiday gifts",
      "Corporate thank-you gifts",
    ],
    goodFor: ["Individuals", "Businesses", "Groups"],
    detailNote: "Popular gift ideas: [add your favorites]",
    image: null,
    imageAlt: "",
    sectionImages: [
      {
        src: "/images/gift-honor-legacy.jpg",
        alt: "'Honor the Legacy. Own Your Line.' — Delta Sigma Theta Edition: red sweatshirt with heavyweight tackle twill '1913', January 13th, and #53 / Fall '25 sleeve embroidery",
      },
      {
        src: "/images/gift-legacy-pride.jpg",
        alt: "'Legacy Worn with Pride' — custom embroidered tackle twill: red '1913' Delta Sigma Theta sweatshirt worn in a wood-paneled library",
      },
      {
        src: "/images/gift-crossing-legacy.jpg",
        alt: "'Wear Your Crossing Legacy' — custom tackle twill and sleeve embroidery on a red '1913' sweatshirt",
      },
      {
        src: "/images/gift-crafted-pride.jpg",
        alt: "'Crafted for Pride' — high-density custom embroidery: purple South Carolina State University hoodie with the Bulldog mascot and Omega Psi Phi sleeve marks",
      },
      {
        src: "/images/gift-rep-legacy.jpg",
        alt: "'Rep Your Legacy' — high-density custom embroidery, authentic game day stitch: purple SC State hoodie worn on the track on game day",
      },
      {
        src: "/images/gift-hoodie-sleeve-art.jpg",
        alt: "'Custom Hoodie — Front, Back & Sleeve Art': red Delta Sigma Theta hoodie with the elephant '53 1913' back art and full sleeve graphics, worn on a brick-wall street",
      },
      {
        src: "/images/gift-hoodie-front-back.jpg",
        alt: "'Custom Hoodie — Front & Back Custom Artwork, Full Sleeve Graphics': red '1913 Delta Sigma Theta' hoodie shown from the front and back in a studio",
      },
      {
        src: "/images/gift-hoodie-street.jpg",
        alt: "'Custom Hoodie — 1913 Delta Sigma Theta, Detailed Sleeve & Back Artwork': red hoodie with elephant back art, worn walking down a mural street",
      },
      {
        src: "/images/gift-wear-legacy-chapter.jpg",
        alt: "'Wear Your Legacy' — custom chapter embroidery and crossing details: red Delta Sigma Theta crewneck with Alpha Xi Spring '25 sleeve art, worn on a campus quad at golden hour",
      },
      {
        src: "/images/gift-crafted-sisterhood.jpg",
        alt: "'Crafted for Sisterhood' — custom tackle twill and detailed embroidery: red Delta Sigma Theta crewneck with Alpha Xi Spring '25 and number 11 embroidery insets, worn against a wood-paneled wall",
      },
      {
        src: "/images/gift-legacy-lettering.jpg",
        alt: "'Wear Your Legacy' — custom embroidered Greek lettering with front, back and sleeve detailing: red Delta Sigma Theta crewneck worn smiling across a busy campus",
      },
      {
        src: "/images/gift-precision-pride.jpg",
        alt: "'Precision Embroidered Pride' — front and back custom detailing: pink Alpha Kappa Alpha hoodies with 'AKA 1908' and a personalized 'Ikonik 35' back",
      },
      {
        src: "/images/gift-aka-legacy.jpg",
        alt: "'Wear Your Legacy' — custom embroidered detailing, Alpha Kappa Alpha 1908: pink AKA hoodies with 'Ikonik 35' back, worn in a city park at sunset",
      },
      {
        src: "/images/gift-crate-keepsake.jpg",
        alt: "'Handcrafted Sisterhood Keepsake' — multi-layered 3D woodwork: red keepsake crate with raised Delta Sigma Theta letters and an elephant silhouette",
      },
      {
        src: "/images/gift-crate-heritage.jpg",
        alt: "'Heritage Craftsmanship' — solid slatted wood build: red keepsake crate with raised Delta Sigma Theta letters and a '21' on the end, in a wood-paneled library",
      },
      {
        src: "/images/gift-crate-1913.jpg",
        alt: "'Custom Keepsake Crate' — handcrafted dimensional woodwork, official Delta Sigma Theta design: red crate with raised black '1913' numbers and elephant emblem, on a smoky red backdrop",
      },
      {
        src: "/images/gift-crate-pride.jpg",
        alt: "'Crafted for Sisterhood Pride' — solid slatted wood construction with dimensional raised detailing: red crate with '1913' and an elephant on the side",
      },
    ],
  },
];

export const GALLERY = [
  {
    id: "g2",
    src: "/images/work-jacket-bulldogs.jpg",
    category: "Embroidery",
    alt: "Green work jacket with a circular 'Skies The Limit Creations' logo patch and 'Bulldogs' embroidered in blue down the sleeve",
    caption: "Logo patch & 'Bulldogs' lettering — jacket",
  },
  {
    id: "g3",
    src: "/images/work-sweatshirt-warriors.jpg",
    category: "Embroidery",
    alt: "Spartan helmet logo and the word 'Warriors' embroidered in blue on a grey sweatshirt",
    caption: "'Warriors' logo — grey sweatshirt",
  },
  {
    id: "g4",
    src: "/images/work-sleeve-1990.jpg",
    category: "Embroidery",
    alt: "Large embroidered '1896' numbers in red and blue running down the sleeve of an SC State heritage jacket",
    caption: "'1896' Heritage numbers — SC State jacket sleeve",
  },
  {
    id: "g6",
    src: "/images/work-tee-portrait.jpg",
    category: "Custom Apparel",
    alt: "White t-shirt with a stylized graphic of a man wearing a fedora hat on the chest",
    caption: "Fedora portrait — custom tee",
  },
  {
    id: "g8",
    src: "/images/work-tee-bruins.jpg",
    category: "Custom Apparel",
    alt: "Man wearing a white t-shirt printed with 'Property of Orangeburg-Wilkinson Bruins 1990' in orange and red",
    caption: "'Bruins 1990' — custom team tee",
  },
  {
    id: "g9",
    src: "/images/work-dtf-rolls.jpg",
    category: "DTF & Printing",
    alt: "Rolls of colorful freshly printed DTF transfers ready to press",
    caption: "Fresh DTF transfers — ready to press",
  },
  {
    id: "g10",
    src: "/images/shop-dtf-printer.jpg",
    category: "DTF & Printing",
    alt: "Our in-house DTF printer at work in the studio",
    caption: "Our in-house DTF printer",
  },
  {
    id: "g11",
    src: "/images/work-3d-letters.jpg",
    category: "3D Printing",
    alt: "3D printed Omega Psi Phi and Delta Sigma Theta Greek letters in official colors, displayed on matching mini easels",
    caption: "Greek letters — 3D printed in official colors",
  },
  {
    id: "g13",
    src: "/images/work-laser-coasters.jpg",
    category: "Laser Engraving",
    alt: "Custom laser-engraved slate coasters with a Masonic square-and-compass design, beside a Skies The Limit Creations business card",
    caption: "Masonic emblem — engraved slate coasters",
  },
  {
    id: "g14",
    src: "/images/work-laser-bulldog-suite.jpg",
    category: "Laser Engraving",
    alt: "Round slate centerpiece plaque laser-engraved with the South Carolina State University Bulldog and alma mater, with matching slate coasters and custom coaster holders",
    caption: "'Bulldog Slate Suite' — SC State plaque & coasters",
  },
  {
    id: "g15",
    src: "/images/work-laser-masonic-set.jpg",
    category: "Laser Engraving",
    alt: "Four natural slate coasters precision laser-engraved with a Masonic square-and-compass emblem",
    caption: "Masonic coasters — engraved slate, set of 4",
  },
];

export const GALLERY_CATEGORIES = [
  "All",
  "3D Printing",
  "Laser Engraving",
  "Embroidery",
  "DTF & Printing",
  "Custom Apparel",
];

// Empty slots so new photos are easy to add — replace with real entries above.
export const PLACEHOLDER_SLOTS = [
  { id: "ph-sublimation", title: "Sublimation", note: "[Add your sublimation photos]" },
  { id: "ph-gifts", title: "Personalized Gifts", note: "[Add your personalized gift photos]" },
];

// The Cap Wall — raised 3D embroidery caps. Add more designs here and they join the wall.
export const CAPS = [
  {
    src: "/images/cap-defined-detail.jpg",
    title: "Defined by Detail",
    sub: "Raised 3D embroidery — maroon classic",
    alt: "Maroon flat-brim cap with raised 3D embroidered black 'STLC' heart logo, worn on a city street — 'Defined by Detail: Raised 3D Embroidery'",
  },
  {
    src: "/images/cap-defined-streets.jpg",
    title: "Defined by the Streets",
    sub: "Raised 3D embroidery · classic flat brim",
    alt: "Black flat-brim cap with raised white 'STLC' script embroidery, worn against a graffiti wall — 'Defined by the Streets'",
  },
  {
    src: "/images/cap-defined-dimension.jpg",
    title: "Defined by Dimension",
    sub: "Heavyweight 3D raised stitching · premium structured twill",
    alt: "Close-up of a black structured twill cap with heavyweight 3D raised white 'STLC' stitching — 'Defined by Dimension'",
  },
  {
    src: "/images/cap-defined-details.jpg",
    title: "Defined by Details",
    sub: "Raised 3D embroidery — grey, against the skyline",
    alt: "Grey cap with raised black 'STLC' script embroidery against a city skyline at sunset — 'Defined by Details'",
  },
  {
    src: "/images/cap-complete-fit.jpg",
    title: "Complete the Fit",
    sub: "Raised 3D embroidery — maroon classic",
    alt: "Maroon cap with raised 3D embroidered black 'STLC' heart logo, worn in a bright loft — 'Complete the Fit: Raised 3D Embroidery'",
  },
  {
    src: "/images/cap-dimension-flat-brim.jpg",
    title: "Defined by Dimension",
    sub: "Raised 3D embroidery · structured flat brim",
    alt: "Grey structured flat-brim cap with raised black 'STLC' script embroidery, worn at dusk on a glowing city street — 'Defined by Dimension'",
  },
  {
    src: "/images/cap-elevate-statement.jpg",
    title: "Elevate Your Statement",
    sub: "Raised 3D embroidery · structured 6-panel fit",
    alt: "Grey and white structured 6-panel cap with raised 3D embroidered black 'STLC' heart logo, worn against a concrete wall — 'Elevate Your Statement'",
  },
  {
    src: "/images/cap-street-wear.jpg",
    title: "Street Wear Defined",
    sub: "Raised 3D embroidery · snapback with side patch",
    alt: "Grey snapback cap with black brim, green undervisor, raised black 'STLC' heart embroidery and a small logo side patch — 'Street Wear Defined'",
  },
  {
    src: "/images/cap-hold-form.jpg",
    title: "Built to Hold Form",
    sub: "Dimensional raised embroidery · rigid 6-panel crown",
    alt: "Grey rigid 6-panel cap with dimensional raised 'STLC' heart embroidery, worn against a sunlit concrete wall — 'Built to Hold Form'",
  },
  {
    src: "/images/cap-elevate-everyday.jpg",
    title: "Elevate Your Everyday",
    sub: "Structured 3D embroidery · rooftop classic",
    alt: "Olive structured cap with black 'STLC' embroidery, worn on a rooftop overlooking the city skyline at sunset — 'Elevate Your Everyday'",
  },
];

export const AUDIENCES = [
  { icon: "user", label: "Individuals", line: "Gifts & personal projects" },
  { icon: "building", label: "Businesses", line: "Branded apparel & giveaways" },
  { icon: "school", label: "Schools", line: "Spirit wear & school pride" },
  { icon: "trophy", label: "Teams", line: "Jackets, jerseys & caps" },
  { icon: "users", label: "Groups", line: "Events & celebrations" },
];

export const OLD_URL_REDIRECTS = [
  { from: "/custom-transfers-by-size", to: "/services#dtf-printing" },
  { from: "/copy-of-custom-transfers-by-size", to: "/services#dtf-printing" },
  { from: "/book-online", to: "/quote" },
  { from: "/blank-12025-01-25", to: "/" },
  { from: "/blank-22025-01-25", to: "/" },
  { from: "/blank-32025-01-25", to: "/" },
  { from: "/blank-42025-01-25", to: "/" },
];
